import http from '../api/api'
import config from '../api/constants'

const getLoanRequestValues = async () => {
  try {
    const response = await http.post(config.apiRoute.GET_LOAN_REQUEST_VALUES)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const requestLoan = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'LOANREQUEST',
    }
    const response = await http.post(config.apiRoute.REQUEST_NEW_LOAN, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getLoanAccounts = async () => {
  try {
    const reqParams = {
      requestId: 'ACCOUNTDETAILS',
      accountType: 'L',
    }
    const response = await http.post(config.apiRoute.GET_ACCOUNTS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getAccountDetails = async ({ accountNo, brnCode }) => {
  try {
    const reqParams = {
      loanAccountNo: accountNo,
      loanAccBrn: brnCode,
      requestId: 'ACCOUNTDETAILS',
      module: 'Loan',
    }
    const response = await   http.post(config.apiRoute.GET_LOAN_DETAILS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const loanRepayVerify = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'REPAYLOAN',
    }
    const response = await http.post(config.apiRoute.REQUEST_LOAN_REPAY_VERIFY, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const loanRepayConfirm = async (reqParams) => {
  try {
    const params = {
      ...reqParams,
      requestId: 'REPAYLOAN',
    }
    const response = await http.post(config.apiRoute.REQUEST_LOAN_REPAY_CONFIRM, params)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getLoanAccountStatement = async ({ accountNo, brnCode }) => {
  try {
    const reqParams = {
      loanAccountNo: accountNo,
      loanAccBrn: brnCode,
      module: 'Loan',
      requestId: 'LOANACCOUNTSTATEMENT',
    }
    const response = await http.post(config.apiRoute.GET_LOAN_STATEMENT, reqParams)
    return response
  } catch (err) {
    throw err.response.data
  }
}

const LoanService = {
  getLoanRequestValues,
  requestLoan,
  getLoanAccounts,
  getAccountDetails,
  loanRepayVerify,
  loanRepayConfirm,
  getLoanAccountStatement
}

export default LoanService